import {
  LayoutDashboard,
  ClipboardList,
  Truck,
  FileText,
  CreditCard,
  BarChart,
  TrendingUp,
  UserRound,
  KeyRound,
  ChevronLeft,
} from "lucide-react";

import logo from "../../assets/images/logo.png";
import { NavLink } from "react-router-dom";

const modules = [
  {
    title: "Core",
    items: [
      {
        label: "Dashboard",
        icon: LayoutDashboard,
        path: "/vendordashboard",
      },
    ],
  },
  {
    title: "Orders",
    items: [
      {
        label: "Purchase Orders",
        icon: ClipboardList,
        path: "/vendordashboard/purchase-orders",
      },
      {
        label: "Delivery Status",
        icon: Truck,
        path: "/vendordashboard/deliveries",
      },
    ],
  },
  {
    title: "Finance",
    items: [
      {
        label: "Payments",
        icon: CreditCard,
        path: "/vendordashboard/payments",
      },
    ],
  },
  {
    title: "Reports",
    items: [
      {
        label: "Purchase Reports",
        icon: BarChart,
        path: "/vendordashboard/reports/purchase",
      },
      {
        label: "Payment Reports",
        icon: TrendingUp,
        path: "/vendordashboard/reports/payments",
      },
    ],
  },
  {
    title: "Account",
    items: [
      {
        label: "My Profile",
        icon: UserRound,
        path: "/vendordashboard/profile",
      },
      {
        label: "Security",
        icon: KeyRound,
        path: "/vendordashboard/security",
      },
    ],
  },
];

export default function VendorSidebar({ collapsed, setCollapsed }) {
  return (
    <aside
      className={`fixed left-0 top-0 z-40 h-screen
      ${collapsed ? "w-20" : "w-72"}
      bg-[#07070b] border-r border-white/10
      transition-all duration-300 flex flex-col`}
    >
      {/* Gold Accent Line */}
      <div className="absolute top-0 left-0 h-full w-[2px] bg-gradient-to-b from-amber-400 via-yellow-500 to-amber-400" />

      {/* Header */}
      <div className="flex items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3 overflow-hidden">
          <img src={logo} className="w-10 h-10 shrink-0" />
          {!collapsed && (
            <div>
              <h2 className="font-serif text-lg">Jaggi Sweets</h2>
              <p className="text-[10px] tracking-[0.3em] text-amber-400">
                VENDOR PORTAL
              </p>
            </div>
          )}
        </div>

        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 rounded-lg hover:bg-white/10 transition"
        >
          <ChevronLeft
            size={18}
            className={`transition-transform ${collapsed ? "rotate-180" : ""}`}
          />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto sidebar-scroll scrollbar-hide px-3 space-y-6">
        {modules.map((section) => (
          <div key={section.title}>
            {!collapsed && (
              <p className="px-3 mb-2 text-[15px] uppercase tracking-widest text-yellow-400">
                {section.title}
              </p>
            )}

            <div className="space-y-1">
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.label}
                    to={item.path}
                    end
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2 rounded-xl text-sm transition
                      ${
                        isActive
                          ? "bg-amber-400/20 text-amber-400"
                          : "text-gray-400 hover:text-white hover:bg-white/5"
                      }`
                    }
                  >
                    <Icon size={18} />
                    {!collapsed && <span>{item.label}</span>}
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      {!collapsed && (
        <div className="px-6 py-4 border-t border-white/10 text-xs text-gray-400">
          © {new Date().getFullYear()} Jaggi Sweets • Vendor Portal
        </div>
      )}
    </aside>
  );
}
